import { jsx as _jsx } from "react/jsx-runtime";
import MuiTypography from '@mui/material/Typography';
import * as React from 'react';
import { Skeleton } from '../skeleton';
import { usePaletteColor } from '../theme';
import { withVersion } from '../utils';
export * from './measure';
export * from './with-tooltip';
export const typographyVariants = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'caption',
    'button',
    'overline'
];
export const typographyTextTransforms = [
    'none',
    'capitalize',
    'uppercase',
    'lowercase',
    'sentence',
    'full-width',
    'full-size-kana',
    'inherit',
    'initial',
    'unset',
    'revert',
    'revert-layer',
    'unset'
];
const TypographyImpl = React.forwardRef(({ variant = 'body2', align = 'left', maxWidth = '100%', color, lineClamp, textTransform, skeleton, children, ...muiProps }, ref) => {
    const paletteColor = usePaletteColor(color);
    const cssLineClamp = (() => {
        if (lineClamp) {
            return getSxLineClamp(lineClamp);
        }
        return undefined;
    })();
    const cssTextTransform = textTransform === 'sentence' ? undefined : textTransform;
    if (skeleton) {
        return (_jsx(Skeleton, { ...(typeof skeleton === 'object' ? skeleton : {}), children: _jsx(MuiTypography, { ref: ref, variant: variant, align: align, maxWidth: maxWidth, textOverflow: "ellipsis", textTransform: cssTextTransform, ...muiProps, sx: {
                    color: paletteColor,
                    ...cssLineClamp,
                    ...muiProps.sx
                }, children: prepareTextTransform(children, textTransform) }) }));
    }
    return (_jsx(MuiTypography, { ref: ref, variant: variant, align: align, maxWidth: maxWidth, textOverflow: "ellipsis", textTransform: cssTextTransform, ...muiProps, sx: {
            color: paletteColor,
            ...cssLineClamp,
            ...muiProps.sx
        }, children: prepareTextTransform(children, textTransform) }));
});
export const Typography = withVersion(TypographyImpl, '1.0.0');
export function getSxLineClamp(lines) {
    return {
        lineClamp: `${lines}`,
        display: '-webkit-box',
        WebkitLineClamp: lines,
        WebkitBoxOrient: 'vertical'
    };
}
export const firstLetterUppercase = {
    ':first-letter': { textTransform: 'uppercase' }
};
export const prepareTextTransform = (element, textTransform) => {
    if (textTransform !== 'sentence') {
        return element;
    }
    return sentence(element);
};
export const sentence = (element) => {
    if (!element) {
        return element;
    }
    if (typeof element === 'string') {
        return `${element[0].toUpperCase()}${element.slice(1)}`;
    }
    return element;
};
